import { campaignBriefApiUrl } from "../constants";
import httpClient from "./http_client";

class CampaignBriefApiService {
  constructor(campaignBriefApiUrl) {
    this.campaignBriefApiUrl = campaignBriefApiUrl;
  }

  async fetchCampaignBriefChatData(params) {
    try {
      const response = await httpClient.post(`${this.campaignBriefApiUrl}/campaign_brief_chat`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async pushCampaignToConfluence(params) {
    try {
      const response = await httpClient.post(`${this.campaignBriefApiUrl}/push_campaign_to_confluence`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

}

const campaignBriefApiService = new CampaignBriefApiService(campaignBriefApiUrl);
export default campaignBriefApiService;
